import React, { useState, useEffect, useWindowFocus} from 'react';

// eslint-disable-next-line 
import { Link } from 'react-router-dom'
import NavBar from "./Navbar"

import './App.css';

function App() { 
    
    
    
    
    
    
    // eslint-disable-line no-unused-vars
return (
  <div className="App22">
           <NavBar />
    <div className="App">
       
      <header className="App-header">
{/* 
        <Link to="/" style={{ textDecoration: 'none' }}>
      Return Home
      </Link> */}

      <div className="centerme">
        For Technical Support:<br />mattkrebsemail@gmail.com.
            </div>
      </header>
    </div>
    </div>
  );
}

export default App;


